import React, { useEffect } from 'react'
import { pageTitle } from '../../helper'
import Card from '../Card'
import Cta from '../Cta'
import PageHeading from '../PageHeading'
import PricingTableList from '../PricingTable/PricingTableList'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function ServicesPage() {
  pageTitle('Service');
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      <PageHeading 
        title='Services'
        bgSrc='images/service_hero_bg.jpeg'
        pageLinkText='Services'
      />
     {/* Start Service Section */}
          <Spacing lg="150" md="80" />
          <Div id="service">
            <Div className="container">
              <Div className="row">
                <Div className="col-xl-4">
                  <SectionHeading
                    title="Services we can help you with"
                    subtitle="What Can We Do"
                    btnText="See All Services"
                    btnLink="/service"
                  />
                  <Spacing lg="90" md="45" />
                </Div>
                <Div className="col-xl-8">
                  <Div className="row">
                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                    <Div className="col-lg-3 col-sm-6">
                      <Card
                        title="Video Editing"
                        link="/service/service-details"
                        src="/images/service 2.jpg"
                        alt="Service"
                      />
                      <Spacing lg="0" md="30" />
                    </Div>
                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                    <Div className="col-lg-3 col-sm-6">
                      <Card
                        title="Motion Graphics & Animation"
                        link="/service/service-details"
                        src="/images/service 4.jpg"
                        alt="Service"
                      />
                      <Spacing lg="0" md="30" />
                    </Div>
                    <Div className="col-lg-3 col-sm-6">
                      <Card
                        title="Content Strategy"
                        link="/service/service-details"
                        src="/images/service 1.jpg"
                        alt="Service"
                      />
                      <Spacing lg="0" md="30" />
                    </Div>
                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                    <Div className="col-lg-3 col-sm-6">
                      <Card
                        title="Brand Design"
                        link="/service/service-details"
                        src="/images/service 3.jpg"
                        alt="Service"
                      />
                      <Spacing lg="0" md="30" />
                    </Div>
                    <Div className="col-lg-3 col-sm-6 cs-hidden_mobile"></Div>
                  </Div>
                </Div>
              </Div>
            </Div>
          </Div>
          {/* End Service Section */}
    
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <SectionHeading
          title='Providing best <br/>pricing for client' 
          subtitle='Pricing & Packaging'
        />
        <Spacing lg='85' md='40'/>
        <PricingTableList/>
      </Div>
      <Spacing lg='125' md='55'/>
      <TestimonialSlider/>
      <Spacing lg='150' md='80'/>
      <Div className="container">
        <Cta 
          title='Let’s disscuse make <br />something <i>cool</i> together' 
          btnText='Apply For Meeting' 
          btnLink='/contact' 
          bgSrc='/images/cta_bg.jpeg'
        />
      </Div>
    </>
  )
}
